import React, {FC, useRef} from 'react';
import {useSelector} from 'react-redux';

import Box from '@mui/material/Box';

import {FormFieldTypes} from 'appRedux/actions/forms/types';
import {RootReducer} from 'appRedux/reducers';

import CustomMarkdown from 'components/MdxEditorField/CustomMarkdown';

import FormFieldWrapper from 'pages/client/form/wrappers/FormFieldWrapper';

import {CLIENT_BACKGROUND_COLOR} from 'config/theme';

interface ComponentType {
    pageId: number;
    sectionId: number;
    formId: number;
    field: FormFieldTypes;
    isPopup: boolean;
    previewMode?: boolean;
    popupItemId?: number;
}

const FormFieldTemplate: FC<ComponentType> = ({pageId, sectionId, formId, field, isPopup, previewMode}) => {
    const {id} = field;

    const ref = useRef<HTMLDivElement | undefined>();

    const {
        requestCase: {
            currentCase: {templates},
        },
    } = useSelector<RootReducer>((state: RootReducer) => state) as RootReducer;

    const currentTemplate = templates ? templates.find(template => template.fieldId === id) : null;

    if (!currentTemplate) return null;

    return (
        <Box
            sx={{
                backgroundColor: CLIENT_BACKGROUND_COLOR,
                borderRadius: 4,
                pl: 2,
                pr: 2,
                pt: 1,
                pb: 1,
            }}
        >
            <FormFieldWrapper
                data-id={`input#form-template-${formId}-${pageId}-${sectionId}-${id}`}
                wrapperRef={ref}
                formId={formId}
                field={field}
                isPopup={isPopup}
                previewMode={previewMode}
                isTemplateField
            >
                <CustomMarkdown initialText={currentTemplate.text} />
            </FormFieldWrapper>
        </Box>
    );
};

export default FormFieldTemplate;
